import React from 'react';

import CharacterProfileContainer from '../components/Characters/ProfileContainer';

const CharacterProfile = () => <CharacterProfileContainer />;

export default CharacterProfile;
